/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Row,
  Col,
  ListGroupItem,
  ListGroup,
  Progress,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label
} from 'reactstrap';
import { Panel } from 'primereact/panel';
import { Ripple } from 'primereact/ripple';
import { Badge } from 'primereact/badge';
// import FeedbackCoaching from './FeedbackCoaching.jsx';
import { Link } from 'react-router-dom';
import ActionPlanScoreSquare from './ActionPlanScoreSquare.jsx';
import { Toolbar } from 'primereact/toolbar';
import Highcharts from 'highcharts';
import { config } from '../../../../utils/config';
import { callApi, getSessionItem, showSweetAlert, tracker } from '../../../../utils/utils';
import FieldDataTable from 'components/Controls/FieldDataTable/FieldDataTable.jsx';
import { Column } from 'primereact/column';
import FieldButton from '../../../../components/Controls/FieldButton/FieldButton.jsx';
import { Dialog } from 'primereact/dialog';
import ActionPlantMonthKPIsPrev from './ActionPlantMonthKPIsPrev.jsx';

const ActionPlanMonthSummary = (props) => {
  /* ################## useState area start ################## */
  const { t } = useTranslation(['focusReport', 'common']);
  const [ClaPuesto, setClaPuesto] = useState(null); 
  const [ClaAnio, setClaAnio] = useState(null); 
  const [ClaMes, setClaMes] = useState(null);  
  const [ActionPlanResultadoMonthList, setActionPlanResultadoMonthList] = useState([]);
  const [AccomplishmentPercentage, setAccomplishmentPercentage] = useState(null);
  const [KPIsOnRedWithAP, setKPIsOnRedWithAP] = useState(null);
  const [ActionPlanMonthResult, setActionPlanMonthResult] = useState(null);
  const [EsActionPlan, setEsActionPlan] = useState(false);
  const [TotalActionPlanDetail, setTotalActionPlanDetail] = useState(null);
  const [NomCumplimiento, setNomCumplimiento] = useState(null);
  const [DetailActionPlanList, setDetailActionPlanList] = useState([]);
  const [ScoreAPFollowUP, setScoreAPFollowUP] = useState(null);
  const [ScoreAPAccomplishment, setScoreAPAccomplishment] = useState(null);
  const [EsKPIsPrev, setEsKPIsPrev] = useState(false);

  useEffect(() => {
    setClaPuesto(props.ClaPuesto === undefined ? 0 : props.ClaPuesto);
    setClaAnio(props.ClaAnio === undefined ? 0 : props.ClaAnio);
    setClaMes(props.ClaMes === undefined ? 0 : props.ClaMes);
    GetActionPlanResultadoMonthPuesto(); 
  }, [props.ClaPuesto, props.ClaAnio, props.ClaMes]);

  const GetActionPlanResultadoMonthPuesto = () => {
    const getActionPlanResultadoMonthPuesto = `${config.UrlApiProject}ScoreCard/GetActionPlanResultadoMonthPuesto`;
    const paramsToService = {
      ClaPuesto: props.ClaPuesto === undefined ? 0 : props.ClaPuesto,
      ClaAnio: props.ClaAnio === undefined ? 0 : props.ClaAnio,
      ClaMes: props.ClaMes === undefined ? 0 : props.ClaMes,
    };
    callApi(getActionPlanResultadoMonthPuesto, 'POST', paramsToService, (response) => {
      const headerResulst = response.data.ActionPlanMonth.length>0? response.data.ActionPlanMonth[0] : {}; 
       
      setAccomplishmentPercentage(headerResulst.AccomplishmentPercentage);
      setKPIsOnRedWithAP(headerResulst.KPIsOnRedWithAP);
      setActionPlanMonthResult(headerResulst.ActionPlanMonthResult);
      setScoreAPAccomplishment(headerResulst.ScoreAPAccomplishment);
      setScoreAPFollowUP(headerResulst.ScoreAPFollowUP);
      setActionPlanResultadoMonthList(response.data.ActionPlanMonthDetail);
    });
  };
  const GetActionPlanDetail = (pnClaCumplimiento) => {
    const getActionPlanDetail = `${config.UrlApiProject}ScoreCard/GetActionPlanDetail`;
    const paramsToService = {
      ClaPuesto,
      ClaAnio,
      ClaMes,
      ClaCumplimiento: pnClaCumplimiento
    };
    callApi(getActionPlanDetail, 'POST', paramsToService, (response) => {
      const headerResulst = response.data.ActionPlanDetailHead.length>0? response.data.ActionPlanDetailHead[0] : {};
      
      
      setTotalActionPlanDetail(headerResulst.Total);
      setNomCumplimiento(headerResulst.NomCumplimiento);
      setDetailActionPlanList(response.data.ActionPlanDetailDetail);
    });
  };
  const PorcTemplate = (rowData) => {
    return (
      <>
        <label>
          {rowData.Porc} %
        </label>
      </>
    );
  };
  const headerActionPlanResultadoMonth = <></>;

  const footer  = ( 
    <> 
      <Row>
        <Column></Column>          
        <Column className="text-center" footer={() => (<b>{ (ActionPlanResultadoMonthList.reduce((a,v) =>  a += v.Quality === null ? 0 : v.Quality , 0 )).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</b>)}></Column>     
        <Column></Column>         
        <Column className="text-center" footer={() => (<b>{ (ActionPlanResultadoMonthList.reduce((a,v) =>  a += v.Point === null ? 0 : v.Point , 0 )).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</b>)}></Column>     
      </Row>
    </>
  )

  const actionBodyTemplateQuality = (rowData, props) => {
    return (
      <>
        <div>
          <Label className='Cursor' onClick={() => onClickViewDetailActionPlan(rowData)}>{rowData.Quality}</Label>          
        </div>
      </>
    );
  }
  const dialogStyle = {
    width: '80vw',
  };

  const closeModalActionPlan = () => {
    setEsActionPlan(false);
  };

  const closeModalKPIsPrev = () => {
    setEsKPIsPrev(false);
  };
  const onViewKPIsPrev = () => { 
    setEsKPIsPrev(!EsKPIsPrev);
  };

  const onClickViewDetailActionPlan = (props) => {    
    setEsActionPlan(!EsActionPlan);
    GetActionPlanDetail(props.CumplimientoID);

    tracker.trackEvent({
      type: 'ActionPlanMonthSummary', /* component name */
      action: 'CLICK_VIEW_ACTIONPLAN_LIST'
    }) 
  };

  const headerActionPlan =(
    <>
      <Row>
        <Col>
          {NomCumplimiento}
        </Col>
        <Col className="text-right">
          {t('focusReport:Total')} : {TotalActionPlanDetail}
        </Col>
      </Row>
        
    </>
      );
  

  return (
    <>
      <Card>
        <CardBody className='action-plan-suummary'>
          <Row>
            <Col className="text-center">
              <h2 className="title-ActionPlan">{t('focusReport:ActionPlan')}</h2>
            </Col>
          </Row>
          <Row className="align-items-start ">
            <Col lg={8} md={8} sm={12} xs={12}>              
              <div style={{ float:'left'}}>
                <span className="h4">{t('focusReport:ActionPlanFinishedOnTime')}</span>&nbsp;({AccomplishmentPercentage}%)
              </div>              
            </Col>
            <Col lg={4} md={4} sm={12} xs={12} className="text-right">
              <h3><span className="title-ActionPlan-Sub">{t('focusReport:Score')}</span>: {ScoreAPAccomplishment !== null && typeof(ScoreAPAccomplishment) === 'number' ?  Highcharts.numberFormat(ScoreAPAccomplishment, 2, '.', ',') : ScoreAPAccomplishment} %</h3>

              
            </Col>
            
          </Row>
          <Row className="align-items-start ">
            <Col lg={8} md={8} sm={12} xs={12}>              
              <div style={{ float:'left'}} onClick={onViewKPIsPrev} className="Cursor">
                <span className="h4">{t('focusReport:KpiTiltle')}</span>&nbsp;({KPIsOnRedWithAP}%)
              </div>               
            </Col>
            <Col lg={4} md={4} sm={12} xs={12} className="text-right">
              <div onClick={onViewKPIsPrev} className="Cursor">
                <h3><span className="title-ActionPlan-Sub">{t('focusReport:Score')}</span>: {ScoreAPFollowUP !== null && typeof(ScoreAPFollowUP) === 'number' ?  Highcharts.numberFormat(ScoreAPFollowUP, 2, '.', ',') : ScoreAPFollowUP} %</h3>
              </div>
            </Col>
          </Row>
          <Row className="align-items-start ">
            <Col lg={12} md={12} sm={12} xs={12} className="text-right">
              <h3><span className="title-ActionPlan-Sub">{t('focusReport:TotalScore')}</span>: {ActionPlanMonthResult !== null && typeof(ActionPlanMonthResult) === 'number' ?  Highcharts.numberFormat(ActionPlanMonthResult, 2, '.', ',') : ActionPlanMonthResult} %</h3>
            </Col>
          </Row>
          <Row className="align-items-start ">
            <Col lg={12} md={12} sm={12} xs={12}>
              <FieldDataTable
                value={ActionPlanResultadoMonthList}
                scrollable 
                footerColumnGroup={footer}
                paginator={false} 
                className="table-header-background-blue"
              >
                <Column
                  field="Description"
                  header={t('focusReport:ActivitiesAccomp')}
                  columnKey="Description"
                  headerStyle={{ width: '145px' }}
                >
                </Column>
                <Column
                  field="Quality"
                  className="text-center"
                  header={t('focusReport:Quality')}
                  columnKey="Quality"
                  headerStyle={{ width: '60px', textAlign: 'center' }}
                  body={(rowData, props) => actionBodyTemplateQuality(rowData, props)} 
                > 
                </Column>
                <Column
                  field="Porc"
                  body={PorcTemplate}
                  className="text-center"
                  header={t('focusReport:Porc')}
                  columnKey="Porc"
                  headerStyle={{ width: '40px', textAlign: 'center' }}
                >
                 
                </Column>
                <Column
                  field="Point"
                  className="text-center"
                  header={t('focusReport:Point')}
                  columnKey="Point"
                  headerStyle={{ width: '60px', textAlign: 'center' }}
                >
                 
                </Column>
              </FieldDataTable>
            </Col>
          </Row>          
        </CardBody>
        <CardFooter hidden={!props.showCloseButton}>
          <Row>
            <Col className='text-center'>
              <FieldButton
                label={t('common:Close')}
                icon="fas fa-times"
                className="warning no-border p-mr-2 rounded-button"
                onClick={typeof(props.onCloseClick) !== 'undefined' && typeof(props.onCloseClick) === 'function' ? props.onCloseClick : null}
              />
            </Col>
          </Row>
        </CardFooter>
      </Card>
      <Dialog
        visible={EsActionPlan}
        header=""
        style={dialogStyle}
        modal
        className="dialog-custom"
        onHide={closeModalActionPlan}
      >
        <Row className="align-items-start">
          <Col lg={12} md={12} sm={12} xs={12}>
            <FieldDataTable
              value={DetailActionPlanList}
              scrollable 
              scrollHeight="330px" 
              className="editable-cells-table"  
              editMode="cell"
              selectionMode="single"
              header={headerActionPlan}
            >
              <Column
                field="TopicoAnalisis"
                header={t('focusReport:AnalysisTopic')}
                columnKey="TopicoAnalisis"
                headerStyle={{ width: '145px' }}
              >
              </Column>
              <Column
                field="DescripcionTarea"                
                header={t('focusReport:DescriptionModal')}
                columnKey="DescripcionTarea"
                headerStyle={{ width: '145px', textAlign: 'center' }}                
              > 
              </Column>
              <Column
                field="FechaReporte"
                className="text-center"
                header={t('focusReport:ReportedDate')}
                columnKey="FechaReporte"
                headerStyle={{ width: '40px', textAlign: 'center' }}
              >
                 
              </Column>
              <Column
                field="FechaCompromiso"
                className="text-center"
                header={t('focusReport:DueDate')}
                columnKey="FechaCompromiso"
                headerStyle={{ width: '60px', textAlign: 'center' }}
              >                 
              </Column>
              <Column
                field="FechaTermino"
                className="text-center"
                header={t('focusReport:CompletedDate')}
                columnKey="FechaTermino"
                headerStyle={{ width: '60px', textAlign: 'center' }}
              >                 
              </Column>
              <Column
                field="DiferenciaDias"
                className="text-center"
                header={t('focusReport:DateDiff')}
                columnKey="DiferenciaDias"
                headerStyle={{ width: '60px', textAlign: 'center' }}
              >                 
              </Column>
              
            </FieldDataTable>
          </Col>
        </Row>
      </Dialog>
      <Dialog
        visible={EsKPIsPrev} 
        style={dialogStyle}
        modal
        className="dialog-transparent"
        contentClassName="dialog-content-transparent"
        closable={false}
        onHide={closeModalKPIsPrev}
      > 
        <Row>
          <Col lg={12} md={12} sm={12} xs={12}> 
            <ActionPlantMonthKPIsPrev
              ClaPuesto={ClaPuesto}
              ClaMes={ClaMes}
              ClaAnio={ClaAnio}
              showCloseButtonKPIsPrev={true}
              onCloseClickKPIsPrev={closeModalKPIsPrev}
            >
            </ActionPlantMonthKPIsPrev>
          </Col>
        </Row>
      </Dialog>
    </>
  );
};

export default ActionPlanMonthSummary;
